import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { useStores } from "../../../stores/store";
import { useTranslation } from "react-i18next";
import Loader from "../../common/loader";

export default function AdminSchoolActivationCodeGenerationPage() {
    const { t } = useTranslation();
    const { auth } = useStores();
    let navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            count: 1,
            lot: ''
        }
    });

    const onSubmit = async (data) => {
        setIsLoading(true);

        try {
            await auth.generateSchoolActivationCodes(data);
            navigate('/admin/school-activation-codes/');
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    }

    if (isLoading)
        return <div className='grid h-screen place-items-center'><Loader /></div>

    return (
        <div className="w-full flex flex-col">
            <div className="flex flex-row justify-center">
                <span className="text-4xl">{t('generateCodes')}</span>
            </div>

            <div className="w-full flex flex-row justify-center mt-6">
                <div className="w-1/3 bg-white">
                    <form className="w-full bg-white flex flex-col gap-4 p-8 rounded-3xl shadow-xl" onSubmit={handleSubmit(onSubmit)}>

                        <div className="flex flex-col">
                            <label className="block text-gray-700 text-sm font-bold mb-2">{t('quantity')} *</label>
                            <input
                                type="number"
                                min="1"
                                max="1000"
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                {...register("count", { required: true, min: 1, max: 1000 })}
                            />
                            {errors.count && <span className="text-red-500 text-sm">{t('fieldMandatory')}</span>}
                        </div>

                        <div className="flex flex-col">
                            <label className="block text-gray-700 text-sm font-bold mb-2">{t('productionLot')}</label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                {...register("lot")}
                            />
                        </div>

                        <button className="bg-primary hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mt-4" type="submit">
                            {t('generate')}
                        </button>
                        <button
                            className="border-2 border-primary text-primary font-bold py-2 px-4 rounded-full"
                            onClick={(e) => { e.preventDefault(); navigate('/admin/school-activation-codes') }}
                        >
                            {t('cancel')}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
